module.exports = __webpack_public_path__ + "static/media/aketch.5433e572.webp";